/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ message: NonNullable<unknown> }} Signup_Checkout_Failed_ToastInputs */



/**
* | output |
* | --- |
* | "Failed to start checkout: {message}" |
*
* @param {Signup_Checkout_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_checkout_failed_toast = /** @type {((inputs: Signup_Checkout_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Checkout_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Echec du demarrage du paiement : ${i?.message}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Start des Bezahlvorgangs fehlgeschlagen: ${i?.message}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Impossibile avviare il checkout: ${i?.message}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Не удалось начать оформление заказа: ${i?.message}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Error al iniciar el pago: ${i?.message}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`结账失败：${i?.message}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`チェックアウトを開始できませんでした: ${i?.message}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`चेकआउट शुरू करने में विफल: ${i?.message}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Falha ao iniciar o checkout: ${i?.message}`)
	return /** @type {LocalizedString} */ (`Failed to start checkout: ${i?.message}`)
});